var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:({ opacity: _vm.opacity }),attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.logoPix}})])}
var staticRenderFns = []

export { render, staticRenderFns }